import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Grid, Button, TextField, Typography } from '@mui/material';
import CircularLoader from 'Components/Loaders/CircularLoader';
import useGlobalState from 'Hooks/useGlobalState';
import mainStyles from 'Styles/mainStyles';
import { useTranslation } from 'react-i18next';


const AddRoomTitle = (props) => {
	const [state, dispatch] = useGlobalState();
	const navigate = useNavigate();
	const location = useLocation();
	const classes = mainStyles();
	const { t } = useTranslation();

	const [title, setTitle] = useState(state.device.metadata.title ? state.device.metadata.title : '');

	useEffect(() => {
		console.log('AddRoomTitle - useEffect')
		// const fetchData = async () => {
		// 	let device = await getDeviceByUuname('skyen'+deviceId)
		// 	dispatch({ device: device });
		// }
		// fetchData();
		console.log(state.device, location)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	const handleConfirm = () => {
		let device = state.device;
		device.metadata.title = title;
		dispatch({ device: device });
		navigate('../addroomdesc')
	}
	return (state.device ?
		<Container component="main" maxWidth="sm">
			<Grid container justifyContent={'center'} alignItems='center'>
				<div className={classes.onboardContainer}>
					<Typography variant="h4" className={classes.title}>{t('Tilføj lokale')}</Typography>
				</div>
				<div className={classes.onboardImageContainer}>
					<img src="/assets/room.png" alt="Lokale" className={classes.onboardImageSkyen} />
				</div>
				<div className={classes.onboardContainer}>
					<Typography variant="h5" className={classes.title}>{t('Tilføj lokale i bygning:')}</Typography>
				</div>
				<div className={classes.onboardContainer}>
					<Typography variant="body1" className={classes.title}>{state.device.registry.name}</Typography>
				</div>
				<div className={classes.onboardContainer}>
					<Typography variant="body2" className={classes.title}>{t('Angiv et statisk lokalenummer som ikke ændres over tid. Brug f.eks. "lokale 2.13" i stedet for "mødelokale".')}</Typography>
				</div>
				<TextField
					autoFocus
					id="roomtitle"
					label={t('titel')}
					variant="outlined"
					className={classes.textField}
					onChange={(event) => setTitle(event.target.value)}
					value={title}
				/>

				<Button onClick={handleConfirm} variant="contained" className={classes.greenButton}>{t('Bekræft lokale')}</Button>
			</Grid>
		</Container>
		:
		<CircularLoader />
	)

}

export default AddRoomTitle;